import GenericAreaPage from "@/components/GenericAreaPage";
import { getAreaContent } from "@/lib/area-content";

const Katy = () => {
  const content = getAreaContent("katy");
  if (!content) return null;
  return <GenericAreaPage content={content} />;
};

export default Katy;